var _circle, _circle2, _circle3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentMastercardLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 24,
    viewBox: "0 0 41 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.666,
    cy: 12,
    r: 12,
    fill: "#CB1216"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.666,
    cy: 12,
    r: 12,
    fill: "#F8AF27"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_31503_26011",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 0,
    width: 25,
    height: 24
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.666,
    cy: 12,
    r: 12,
    fill: "#CB1216"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_31503_26011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.666 12C24.666 18.6274 19.2934 24 12.666 24C6.0386 24 0.666016 18.6274 0.666016 12C0.666016 5.37258 6.0386 0 12.666 0C19.2934 0 24.666 5.37258 24.666 12Z",
    fill: "#FF6600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMastercardLogo);
export default __webpack_public_path__ + "static/media/payment-mastercard-logo.a358733d1146988264f498ef67073a2c.svg";
export { ForwardRef as ReactComponent };